module.exports = __webpack_public_path__ + "img/nco.d44c2b04.jpeg";